import { Text } from "@rivet-gg/components";

export function BackendEventDetailsWipTab() {
	return (
		<div className="flex h-full items-center justify-center w-full">
			<Text className="text-muted-foreground">Not implemented yet.</Text>
		</div>
	);
}
